import { useEffect, useState } from 'react';
import { app } from "../../../service/serviceLMS"
import ReactPlayer from 'react-player';
import Modal from 'antd/lib/modal/Modal';
import './VideoModal.css';



export default function VideoModal({ isOpen, fileName, resourceType, onClose }) {
  const [videoUrl, setVideoUrl] = useState(null);

  useEffect(() => {
    if (isOpen && fileName) {

      if (resourceType === "youtube-link" || fileName.includes("youtube.com")) {
        console.log("YouTube link detected:", fileName);
        setVideoUrl(fileName); // Directly use YouTube link
      } else if (resourceType === "video" || fileName.endsWith(".mp4") || fileName.endsWith(".mov")) {
        // const url = app.get(`/course/api/client-api/streaming/video/${fileName}`)
        // console.log("Video URL:", url);
        // Set video URL directly – browser handles range requests
        console.log("Setting video URL for streaming:", fileName);
        const url = `${process.env.REACT_APP_API_BASE_URL}/course/api/client-api/streaming/video/${fileName}`;
        console.log("Video URL set to:", url);
        setVideoUrl(url);
      } else {
        setVideoUrl(fileName)
      }


    }

    // console.log("VideoModal isOpen:", isOpen, "fileName:", fileName, "videoUrl:", videoUrl);
    // return () => {
    //   setVideoUrl(null); // Clear URL on close or re-render
    // };
  }, [isOpen, fileName, resourceType]);

  if (!isOpen) return null;

  return (

    <div className='show-content-container'>
      {/* <button
        className="close-button"
        onClick={onClose}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          zIndex: 1000,
          background: 'rgba(0,0,0,0.7)',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          cursor: 'pointer'
        }}
      >
        ×
      </button> */}
      <ReactPlayer
        url={videoUrl}
        controls
        width="100%"
        height="100%"
        className="video-player"
      />
      {/* <button onClick={onClose}>Close</button> */}

    </div>

  );
}

